import { User } from "../model/User";
import axiosInstance from "../utils/ApiUtils/axiosInstance";

export const fetchUsers = async (): Promise<User[]> => {
  const response = await axiosInstance.get<ApiResponse<User[]>>("/api/user/list");
  return response.data.data || [];
};
